import React, { useState, useEffect, Fragment } from 'react';
import PaymentRow from './PaymentRow';
import { useDispatch } from 'react-redux';
import { showModal } from '../../../actions/modal';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const PaymentsBlock = (props) => {
  const { values, checkoutSettings, handleChangePayment, handleDeletePayment } = props;

  const { t } = useAutoTranslation();

  const { payments } = values;

  const dispatch = useDispatch();

  const handleEditPaymentSettings = (payment) => {
    dispatch(
      showModal('EditPaymentSettings', {
        payment,
        handleChangePayment,
        //Проверка на уникальность кодов не выполняется для уже существующих записей поскольку у них нельзя менять код
        existsCodes: !payment ? payments.map((payment) => payment.paymentMethod.code) : [],
        values,
      }),
    );
  };

  const { commercialAccount } = checkoutSettings;

  return (
    <Fragment>
      <div className="border-bottom">
        <h4 className="header-title">{t('Оплата')}</h4>
      </div>

      <div style={{ paddingTop: '16px' }}>
        {!commercialAccount ? (
          <div className="alert alert-warning" role="alert">
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <i className="fe-alert-circle mr-2" style={{ fontSize: '20px' }} />
              <span>
                {t(
                  'Учетная запись не привязана к юридическому лицу. Редактирование способов оплаты не доступно',
                )}
                .
              </span>
            </div>
          </div>
        ) : null}

        <div className="row" style={{ marginBottom: '16px' }}>
          <div className="col-lg-6" style={{ display: 'flex', alignItems: 'center' }}>
            <h4 style={{ margin: 0, fontSize: '.95rem' }}>{t('Способы оплаты')}</h4>
          </div>
          <div className="col-lg-6">
            <div className="text-lg-right">
              {commercialAccount ? (
                <button
                  className="btn btn-danger waves-effect waves-light"
                  type="button"
                  onClick={() => handleEditPaymentSettings(null)}
                >
                  {t('Новый способ оплаты')}
                </button>
              ) : null}
            </div>
          </div>
        </div>

        <div className="fixed-table-container">
          <div className="table-responsive">
            <table className="table table-centered table-hover">
              <thead className="thead-light">
                <tr>
                  <th>{t('Наименование / код')}</th>
                  <th>
                    {t('Тип')}
                    <span className="help-tooltip-wrapper">
                      <i className="fe-help-circle" />
                      <span className="help-tooltip">
                        {t('Тип способа оплаты')}:{' '}
                        {t('online — оплата картой онлайн через платежного провайдера (эквайринг)')}
                        , {t('cod_card / cod_cash — оплата при доставке')},{' '}
                        {t(
                          'no_cod — управление оплатой вручную, отгрузка заказа без установки оплачен невозможна',
                        )}
                        ,{' '}
                        {t(
                          'no_cod_no_control — управление оплатой вручную, но наличие факта оплаты не контролируется, заказ будет отгружен не дожидаясь факта оплаты',
                        )}
                        .
                      </span>
                    </span>
                  </th>
                  <th>
                    {t('Скидка')}
                    <span className="help-tooltip-wrapper">
                      <i className="fe-help-circle" />
                      <span className="help-tooltip">
                        {t(
                          'Скидка на способ оплаты отображается покупателю в процессе оформления заказа, и позволяет мотивировать выбор определенного способа оплаты',
                        )}
                        .
                      </span>
                    </span>
                  </th>
                  <th>
                    {t('Видимость')}
                    <span className="help-tooltip-wrapper">
                      <i className="fe-help-circle" />
                      <span className="help-tooltip">
                        {t(
                          'Управляет видимостью способа оплаты для покупателей в процессе оформления заказа',
                        )}
                        .
                      </span>
                    </span>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {payments
                  ? payments.map((payment, index) => (
                      <PaymentRow
                        payment={payment}
                        checkoutSettings={checkoutSettings}
                        handleEditPaymentSettings={handleEditPaymentSettings}
                        key={payment.paymentMethod.code}
                        handleDeletePayment={handleDeletePayment}
                        paymentProvider={values.paymentProvider}
                      />
                    ))
                  : null}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default PaymentsBlock;
